import React from 'react'
import { toast } from '../ui/Toast'

export class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    toast.error('Something went wrong. Please refresh and try again.', {
      details: error.stack || error.message,
    })
    console.error(error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex justify-center mt-10">
          <span className="text-slate-500">
            Something went wrong loading this page.
          </span>
        </div>
      )
    }
    return this.props.children
  }
}
